import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';
@Component({
  selector: 'app-set-language',
  templateUrl: './set-language.component.html',
  styleUrls: ['./set-language.component.scss']
})
export class SetLanguageComponent implements OnInit {

  language: any;
  
  /**
   * Creates an instance of set language component.
   * @param commonService 
   */
  constructor(public commonService: CommonService) 
  { 
    this.language = localStorage.getItem("language") || "en"
  }

  ngOnInit(): void {}
  /**
   * Sets language
   * @param lang 
   */
  setLanguage(lang: any){
    this.language = lang
  }
}
